import React from 'react';
import TutorLogo from 'src/app/components/TutorLogo/TutorLogo';
import styles from './SplashScreen.module.scss';
import { TIMEOUTS } from 'src/app/constants';

function SplashScreen() {
  console.log(">>>>>", TIMEOUTS.DELAY_SCREEN_RENDER)
  const animationDelay = (TIMEOUTS.DELAY_SCREEN_RENDER/1000) - 0.5;
  return (
    <div className={`${styles.splashScreenContainer}`} style={{ animationDelay: `${animationDelay}s`}}>
      <TutorLogo withLogoText />
    </div>
  );
}
export default SplashScreen;
